// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1rdHm","content":"RecentSearches_content__NsnJO"};